var map = {
	"./apalla-front.jpg": 4877,
	"./avenuea-front.jpg": 5197,
	"./canadianmilk-front.jpg": 823,
	"./csj-front.jpg": 1651,
	"./evree-front.jpg": 3168,
	"./fwc-front.jpg": 83,
	"./oanda-front.jpg": 9065,
	"./rakuten-front.jpg": 9895,
	"./rikkitikki-front.jpg": 3471,
	"./tdaeroplan-front.jpg": 6641,
	"./tdhousie-front.jpg": 3675,
	"./ugo-front.jpg": 7687,
	"./whatsinmyfood-front.jpg": 6513
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9511;